export var RefreshStatus = /*#__PURE__*/function (RefreshStatus) {
  RefreshStatus["INITIALISED"] = "INITIALISED";
  RefreshStatus["SUCCESS"] = "SUCCESS";
  RefreshStatus["ERROR"] = "ERROR";
  return RefreshStatus;
}({});
export var FeatureFlagServiceApiVersion = /*#__PURE__*/function (FeatureFlagServiceApiVersion) {
  FeatureFlagServiceApiVersion["V1"] = "v1";
  FeatureFlagServiceApiVersion["V2"] = "v2";
  return FeatureFlagServiceApiVersion;
}({});